"use client"

import React from "react"
import { ButtonGroup } from "@/components/molecules/ButtonGroup"
import { CompactedSearchForm } from "@/components/organisms/SearchHomeForm/compacted"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import { ReactQueryProvider } from "@/contexts/QueryProvider"
import HeroCarousel from "../../organisms/Carousel/HeroCarousel"

export const PropertyForm: React.FC<{ translations: Record<string, any> }> = ({ translations }) => {

  const realEstateSlides = [
    'https://images.unsplash.com/photo-1486325212027-8081e485255e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1613490493576-7fde63acd811?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
    'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80'
  ];

  const renderSlide = (slide: string, index: number) => (
    <div
      key={index}
      className="relative w-full h-[750px] lg:h-[400px]"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${slide})` }}
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/80 to-gray-800/80" />
    </div>
  );

  return (
    <ReactQueryProvider>
      <section className="relative w-full overflow-y-visible">
        <HeroCarousel
          slides={realEstateSlides}
          renderSlide={renderSlide}
          contentPosition="static-overlay"
          staticContent={
            <section className="w-full relative md:py-14 p-6">
              <div className="mx-auto grid max-w-screen-2xl">
                <div className="container duration-500">
                  <div className="flex-1 break-words md:break-keep text-center">
                    <HeadingText className="max-w-prose font-sans text-white" level={1}>
                      {translations.headerLabel}
                    </HeadingText>
                  </div>
                </div>
              </div>
              {/* Overlay Search Form */}
              <div className="mx-auto w-11/12 max-w-screen-2xl">
                <ButtonGroup translations={translations} />
                <CompactedSearchForm showRooms={false} showSearch={true} translations={translations} />
              </div>
            </section>
          }
          autoPlay={true}
          interval={3000}
        />
      </section>
    </ReactQueryProvider>
  )
}
